import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, MailCheck } from "lucide-react";
import { api, errorMessage } from "@/lib/api";
import { AuthShell, AuthInput, PrimaryButton } from "@/components/auth/AuthShell";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      setSent(true);
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Reset your password"
      subtitle="Enter the email linked to your account and we will send you a reset link."
      footer={
        <Link to="/login" className="font-semibold text-primary hover:underline" data-testid="forgot-back-to-login">
          Back to sign in
        </Link>
      }
    >
      {sent ? (
        <div className="emerge-card flex items-start gap-3 p-5" data-testid="forgot-success">
          <MailCheck className="mt-0.5 h-5 w-5 text-[hsl(var(--app-leaf))]" />
          <p className="text-sm text-foreground">If an account exists for <strong>{email}</strong>, a reset link is on its way. The link is valid for one hour.</p>
        </div>
      ) : (
        <form onSubmit={onSubmit} className="space-y-5">
          <AuthInput label="Email" id="email" type="email" data-testid="forgot-email-input" value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus />
          {error && <p className="field-error" role="alert">{error}</p>}
          <PrimaryButton loading={loading} data-testid="forgot-submit-button">
            {loading && <Loader2 className="h-4 w-4 animate-spin" />} Send reset link
          </PrimaryButton>
        </form>
      )}
    </AuthShell>
  );
}
